import styles from './ExpertCardExperience.module.scss';

type ExpertCardExperienceProps = {
  experience: number;
};

export const ExpertCardExperience = ({ experience }: ExpertCardExperienceProps) => {
  return (
    <>
      <span className={styles.title} itemProp="value">
        {experience} years
      </span>

      <span className={styles.text}>of experience</span>
    </>
  );
};

export default ExpertCardExperience;
